<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
import { ref, onMounted,defineProps,watchEffect } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Array,
    default: () => [],
  },
})
// console.log(props.leftData2);
const myEcharts = ref(null);

onMounted(() => {

  initChart(props.listData);
});


function initChart(listData) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);

  // let data = [
  //   { name: '烟薯', value: 70 },
  //   { name: '商薯', value: 30 },
  //   { name: '蜜薯', value: 50 },
  //   { name: '龙薯', value: 20 },
  //   { name: '济薯', value: 16 },
  //   { name: '其他', value: 24 },
  // ]
  var size = 2;
  var result = splitArray(listData.list, size);
// const colors = ['#FCD31F', '#03FF4A', '#0000FF', '#037CFF', '#FF7723', '#40FFE5']
  const colors = ['#03FF4A', '#037CFF', '#FF7723', '#40FFE5','#11D1F7', '#FCD31F',]
  const chartData = listData.list.map((item, index) => ({
    value: item.value,
    name: item.name,
    itemStyle: {
      shadowBlur: 20,
      shadowColor: `#${(((index + 1) % 7) + 10) * 100 + 99}`,
      shadowOffsetx: 25,
      shadowOffsety: 20,
      color: colors[index % colors.length],
    },
  }))
  const sum = chartData.reduce((per, cur) => per + cur.value, 0)
  const gap = (1 * sum) / 300
  const pieData1 = []
  const gapData = {
    name: '',
    value: gap,
    itemStyle: {
      color: 'transparent',
    },
  }

  for (let i = 0; i < chartData.length; i++) {
    // 第一圈数据
    pieData1.push({
      ...chartData[i],
    })
    pieData1.push(gapData)
  }

  const option= {
    title: {
      show: true,
      text: listData.name,
      subtext: '',
      x: '34%',
      y: '49%',
      itemGap: 6,
      textStyle: {
        color: '#fff',
        fontSize: 50,
        fontWeight: '400',
        lineHeight: 6,
      },
      subtextStyle: {
        color: '#fff',
        fontSize: 8,
        fontWeight: '400',
        lineHeight: 6,
      },
      textAlign: 'center',
    },
    // legend:[
    //  {
    //    icon: 'circle',
    //    orient: 'horizontal' ,
    //    align:"left",
    //    textStyle: {
    //      color: '#f2f2f2',
    //      fontSize: '24',
    //      height: 30
    //    },
    //    top: '32%',
    //    left: '40%',
    //    itemGap: 20,
    //    itemHeight: 14,
    //    itemWidth: 14,
    //    data: result[0],
    //    formatter: function (name) {
    //      const selectedItem = chartData.find((item) => `${item.name}`.includes(`${name}`));
    //      if (selectedItem) {
    //        const { value } = selectedItem;
    //        const p = ((value / sum) * 100).toFixed(2);
    //        const area = `${value}m²`;
    //        return `${name}  ${p}%`;
    //      } else {
    //        return name;
    //      }
    //    }
    //  },{
    //     icon: 'circle',
    //     orient: 'horizontal' ,
    //     align:"left",
    //     textStyle: {
    //       color: '#f2f2f2',
    //       fontSize: '24',
    //       height: 30
    //     },
    //     top: '45%',
    //     left: '40%',
    //     itemGap: 20,
    //     itemHeight: 14,
    //     itemWidth: 14,
    //     data: result[1],
    //     formatter: function (name) {
    //       const selectedItem = chartData.find((item) => `${item.name}`.includes(`${name}`));
    //       if (selectedItem) {
    //         const { value } = selectedItem;
    //         const p = ((value / sum) * 100).toFixed(2);
    //         const area = `${value}m²`;
    //         return `${name}  ${p}%`;
    //       } else {
    //         return name;
    //       }
    //     }
    //   },{
    //     icon: 'circle',
    //     orient: 'horizontal' ,
    //     align:"left",
    //     textStyle: {
    //       color: '#f2f2f2',
    //       fontSize: '24',
    //       height: 30
    //     },
    //     top: '58%',
    //     left: '40%',
    //     itemGap: 20,
    //     itemHeight: 14,
    //     itemWidth: 14,
    //     data: result[2],
    //     formatter: function (name) {
    //       const selectedItem = chartData.find((item) => `${item.name}`.includes(`${name}`));
    //       if (selectedItem) {
    //         const { value } = selectedItem;
    //         const p = ((value / sum) * 100).toFixed(2);
    //         const area = `${value}m²`;
    //         return `${name}  ${p}%`;
    //       } else {
    //         return name;
    //       }
    //     }
    //   }
    // ],
    legend: {
      orient: 'vertical',
      icon: 'circle',
      textStyle: {
        color: '#f2f2f2',
        fontSize: 26,
      },
      top: 'center',
      left: '65%',
      itemGap: 16,
      itemHeight: 14,
      itemWidth: 14,
      data: chartData,
      formatter: function (name) {
        const selectedItem = chartData.find((item) => `${item.name}`.includes(`${name}`));
        if (selectedItem) {
          const { value } = selectedItem;
          // const p = ((value / sum) * 100).toFixed(2);
          const area = `${value}m²`;
          return `${name}  ${value}%`;
        } else {
          return name;
        }
      }
    },
    series: [
      // 中间圆环
      {
        name: '',
        type: 'pie',
        roundCap: true,
        radius: ['42%', '58%'],
        center: ['35%', '50%'],
        data: pieData1,
        labelLine: {
          length: 18,
          length2: 10,
          lineStyle: {
            width: 1,
          },
        },
        label: {
          show: false,
          fontFamily: 'ysbth',
          position: 'outside',
          // padding: [0, -4, 0, -4],
          formatter(params) {
            if (params.name === '') {
              return ''
            }
            return `${params.value}%`
            // return `${params.percent.toFixed(0)}%`
          },
          color: '#fff',
          fontSize: '30',
          lineHeight: 10,
        },
        emphasis: {
          // 鼠标移入时显示
          label: {
            show: true,
          },
        },
      },
      // 最里面圆环
      {
        type: 'pie',
        radius: ['31%', '32%'],
        center: ['35%', '50%'],
        animation: false,
        hoverAnimation: false,
        data: [
          {
            value: 100,
          },
        ],
        label: {
          show: false,
        },
        itemStyle: {
          color: '#116465',
        },
      },
      // 最外面的圆环
      {
        type: 'pie',
        color: ['#0E494B', 'rgba(0,0,0,0)', '#0E494B', 'rgba(0,0,0,0)'],
        radius: ['65%', '70%'],
        center: ['35%', '50%'],
        label: {
          show: false,
        },
        select: {
          display: false,
        },
        tooltip: {
          show: false,
        },
        data: [100]
      },
    ],
  };// 将你的ECharts配置项放在这里
  chartInstance.setOption(option);

}
window.addEventListener("resize", () => {
  chartInstance.resize();
});
function splitArray(array, size) {
  var result = Array.from({ length: Math.ceil(array.length / size) }, function(_, index) {
    return array.slice(index * size, index * size + size);
  });
  return result;
}
</script>
<style lang="less"></style>
